import React from 'react';
import SEO from '../components/common/SEO';
import Layout from '../components/layout/Layout';
import BlogHero from '../components/home/BlogHero';
import LatestPosts from '../components/home/LatestPosts';
import TopicsStrip from '../components/home/TopicsStrip';
import AboutStrip from '../components/home/AboutStrip';
import { siteConfig } from '../config/site';

const HomePage: React.FC = () => {
  return (
    <Layout>
      <SEO
        title={`${siteConfig.brand.name} — USDT flashing, stablecoins & blockchain blog`}
        description={`Guides, tutorials, and analysis on flash USDT, TRC-20/ERC-20, stablecoins, and blockchain — from ${siteConfig.brand.name}.`}
        keywords="USDT flashing blog, flash USDT guide, USDT tutorials, TRC-20 blog, stablecoin blog, blockchain articles, cryptocurrency blog"
      />
      <BlogHero />
      <LatestPosts />
      <TopicsStrip />
      <AboutStrip />
    </Layout>
  );
};

export default HomePage;
